// extracted by mini-css-extract-plugin
export default {"community":"communityWindow_community__yi0yf"};